import { render, staticRenderFns } from "./HDPadecimientos.vue?vue&type=template&id=4955d5c5&scoped=true"
import script from "./HDPadecimientos.vue?vue&type=script&lang=js"
export * from "./HDPadecimientos.vue?vue&type=script&lang=js"
import style0 from "./HDPadecimientos.vue?vue&type=style&index=0&id=4955d5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955d5c5",
  null
  
)

export default component.exports